export default __webpack_public_path__ + "static/media/upclose.fb37f152.jpg";